const FIELD_EVENT_CLASS_NAMES = {
  FIELD: 'field-adjusted',
  DOTS_FIELD: 'field-dot-zone',
};

export { FIELD_EVENT_CLASS_NAMES };
